<template lang="pug">
  div(class="container")
    v-row(v-if="slider").px-4
      v-flex(xs12 md6 lg6)
        v-slider(label="Time Scale:" v-model="tick" :tick-labels="timescale" :max="years-1" step="1" ticks="always" tick-size="6" @click="replot()").pr-4
      v-flex(xs12 md4 lg4)
        v-slider(label="Duration:" v-model="durationSlider" thumb-label="always" :max="maxDuration" :min="1" @click="replot()").pr-4
      v-flex(xs12 md2 lg2)
        v-checkbox(v-model="showTotals" label="Show Totals" @change="replot").mt-0
   
    bar-chart(v-if="loaded" :chartdata="chartdata" :options="options" :componentkey="componentkey")
    
    div(class="text-center" v-if="!loaded").mt-12
      v-progress-circular(indeterminate class="mb-2" :size="50" :width="5" color="primary")
    
</template>

<script>
import BarChart from "../BarChart";
import moment from "moment";

export default {
  name: "OutdoorWirelessStats",
  props: ["slider", "groupby", "duration", "startyear"],
  components: { BarChart },
  data: () => ({
    loaded: false,
    chartdata: Object,
    options: Object,
    years: 2,
    timescale: [],
    tick: Number,
    componentkey: 0,
    durationSlider: Number,
    maxDuration: 12,
    colors: Object,
    sYear: Number,
    data: [],
    allData: [],
    showTotals: false
  }),
  async mounted() {
    this.colors = {
      one: "#4e79a6",
      two: "#f28e2c",
      three: "#e15759",
      four: "#76b7b2",
      five: "#59a14f",
      six: "#edc949",
      seven: "#af7aa1",
      eight: "#ff9da7",
      nine: "#9c755f",
      ten: "#bab0ab",
      eleven: "#80b1d3",
      twelve: "#bebada",
      thirteen: "#8dd3c7",
    };
    this.durationSlider = this.duration
    this.timescale = this.slider
      ? [...Array(this.years).keys()].map((element, index) => this.sYear = this.startyear - index).sort()
      : [];
    this.tick = this.timescale.length - 1;
    this.getData()
      .then(this.plotData);
  },
  methods: {
    replot() {
      this.plotData(this.allData)
    },
    getRandom(obj) {
      var keys = Object.keys(obj);
      return obj[keys[ keys.length * Math.random() << 0]];
    },
    trimEllip(str, length) {
      return str.length > length ? str.substring(0, length) + "..." : this;
    },
    getData() {
      return new Promise(resolve => {
        fetch(
          `https://datahub-datasets.s3.amazonaws.com/Uploads/AutomatedJobs/Outdoor+Wireless+Usage+Stats.json`
        ).then(response => {
          resolve(response.json());
        });
      });
    },

    plotData(data) {
      if (!this.loaded) this.allData = data;
      data = JSON.parse(JSON.stringify(data))
      data = data.map(a => {
        let newObj = {}
        for (const [key, value] of Object.entries(a)) {
          let newKey = key.replace("GMT+0000 (Coordinated Universal Time)", "GMT-0500 (Eastern Standard Time)")
          newObj[newKey] = value == 'Aurora Hills Branch Library/VA Highlands Park' ? 'Aurora Hills Br Library/VA Highlands Pk' : value
        }
        return newObj
      })
      this.data = data;
      if(this.showTotals) {
        data = data.filter(d => d['County Hotspot'] === "Total Authenticated Access By Month")
      } else {
        data = data.filter(d => d['County Hotspot'] !== "Total Authenticated Access By Month" && d['County Hotspot'] !== "Month")
      }

      let monthData = Object.getOwnPropertyNames(data[0])
      monthData.shift();
      if(monthData[monthData.length - 1] == '__ob__') {
        monthData.pop();
      }

      let yearArray = monthData.map(a => {let tempDate = new Date(a); return tempDate.getFullYear()})
      let uniqueYears = [...new Set(yearArray)]
      this.timescale = uniqueYears
      this.years = uniqueYears.length
      if(!this.loaded) this.tick = this.timescale.length - 1;

      // show last 3 months data
      if(!this.slider) {
        monthData = monthData.slice(-3)
      }
      else {
        let yr = this.timescale[this.tick]

        monthData = monthData.filter(a => {
          let tempDate = new Date(a)
          return tempDate.getFullYear() == yr
        })

        monthData = monthData.slice(-this.durationSlider)
      }

      let datasets = monthData.map(m => {
        return {
          label: moment.utc(m).format("MMM YYYY"),
          backgroundColor: this.getRandom(this.colors),
          //Data to be represented on y-axis
          data: [...data.map(d => d[m])]
        }
      })

      this.chartdata = {
        //Data to be represented on x-axis
        labels: [...data.map(d => { if(d['County Hotspot'] == "Total Authenticated Access By Month") d['County Hotspot'] = "Month"; return d['County Hotspot'] } )],
        datasets: datasets
      };

      var self = this

      this.options = {
        scales: {
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true,
                userCallback: function(value) {
                  return value.toLocaleString();
                }
              },
              gridLines: {
                display: true
              },
              scaleLabel: {
                display: true,
                labelString: "ArlingtonWireless Total Users"
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                callback: function(value) {
                  return !self.slider && value != null ? value.substring(0, 10) + "..." : value
                },
              },
              gridLines: {
                display: true
              },
              scaleLabel: {
                display: true,
                labelString: this.showTotals ? "All County Hotspot Locations" : "Hotspot Location"
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var tooltipValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return parseInt(tooltipValue).toLocaleString();
            }
          }
        },
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false
      };
      this.componentkey += 1;
      this.loaded = true;
    }
  },

  computed: {},
  watch: {}
};
</script>